import { FormEvent, useState } from "react";
import { api } from "../api";

export default function ChangePassword({ onDone }: { onDone: () => void }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (next !== confirm) {
      setError("passwords do not match");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.post("/api/auth/change-password", { current_password: current, new_password: next });
      onDone();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="h-screen grid place-items-center">
      <form onSubmit={submit} className="card w-80 space-y-4">
        <div>
          <div className="text-lg font-bold">Set a new password</div>
          <div className="text-xs text-slate-500">Required on first login. 10+ characters.</div>
        </div>
        <div>
          <label className="label">Current password</label>
          <input className="input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
        </div>
        <div>
          <label className="label">New password</label>
          <input className="input" type="password" value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        <div>
          <label className="label">Confirm new password</label>
          <input className="input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        {error && <div className="text-down text-xs">{error}</div>}
        <button className="btn btn-primary w-full" disabled={busy || next.length < 10}>
          {busy ? "…" : "Change password"}
        </button>
      </form>
    </div>
  );
}
